module.exports = __webpack_public_path__ + "static/media/uanalytics-header-bg.05d8c29a.svg";